// @ts-expect-error no types from package
import HubSpotOnlyAppCookieLogin from 'Nabisco/app/HubSpotOnlyAppCookieLogin';
import { stringify } from 'hub-http/helpers/params';
import SsoLoginDao from '../data/SsoLoginDao';
import { getWindowUrl } from '../utils/urls';
import openPopup from '../utils/openPopup';
import { FAILED_LOGIN_PAGES } from '../constants/FailedLoginPages';
import { isPopupError } from '../utils/browserSupport';
import { SSO_LOGIN_POPUP_URL, SSO_LOGIN_POPUP_NEXTPATH, SSO_LV_TWO_FACTOR, SSO_LV_CONFIRM_TO_LOGIN } from '../constants/SmartLogin';
import { setTwoFactorMethod, setCredentials } from './index';
const appCookieLogin = new HubSpotOnlyAppCookieLogin({
  passThroughFallback: true
});
const ssoLoginDao = new SsoLoginDao();
export const SsoLoginActionTypes = {
  SSO_LOGIN_BEGIN: 'SSO_LOGIN_BEGIN',
  SSO_LOGIN_SUCCESS: 'SSO_LOGIN_SUCCESS',
  SSO_LOGIN_FAILURE: 'SSO_LOGIN_FAILURE'
};
const POPUP_WINDOW = {
  width: 500,
  height: 600
};

const handleError = ({
  responseJSON,
  history,
  dispatch
}) => {
  if (responseJSON) {
    const {
      status
    } = responseJSON;

    if (status in FAILED_LOGIN_PAGES) {
      const nextPath = `${FAILED_LOGIN_PAGES[status]}?${stringify({
        email: responseJSON.errorTokens.email[0]
      })}`;
      history.push(nextPath);
    } else {
      dispatch({
        type: SsoLoginActionTypes.SSO_LOGIN_FAILURE,
        error: status
      });
    }
  } else {
    dispatch({
      type: SsoLoginActionTypes.SSO_LOGIN_FAILURE,
      error: 'LOGIN_UNAVAILABLE'
    });
  }
};

export const loginWithSso = ({
  email,
  forceAuth,
  // to do later
  loginPortalId,
  loginRedirectUrl,
  history
}) => dispatch => {
  dispatch({
    type: SsoLoginActionTypes.SSO_LOGIN_BEGIN
  });
  ssoLoginDao.startLogin({
    email,
    forceAuth,
    loginPortalId,
    loginRedirectUrl
  }).then(response => {
    dispatch({
      type: SsoLoginActionTypes.SSO_LOGIN_SUCCESS
    });
    appCookieLogin.redirectOnLoginSuccess([response]);
  }).catch(({
    responseJSON
  }) => {
    return handleError({
      responseJSON,
      history,
      dispatch
    });
  });
};

const setStateForLV = (eventData, dispatch) => {
  const {
    email,
    token,
    primary,
    secondary,
    backupCodesEnabled
  } = eventData.lvState;

  switch (eventData.method) {
    case SSO_LV_TWO_FACTOR:
      {
        dispatch(setTwoFactorMethod(token, primary, secondary, backupCodesEnabled));
        break;
      }

    case SSO_LV_CONFIRM_TO_LOGIN:
      dispatch(setTwoFactorMethod(token, null, null, false));
      dispatch(setCredentials({
        email
      }));
      break;

    default:
      break;
  }
};

export const loginWithSsoWithPopup = ({
  email,
  forceAuth,
  loginPortalId,
  loginRedirectUrl,
  history
}) => dispatch => {
  dispatch({
    type: SsoLoginActionTypes.SSO_LOGIN_BEGIN
  });
  ssoLoginDao.startLogin({
    email,
    forceAuth,
    loginPortalId,
    loginRedirectUrl
  }).then(response => {
    dispatch({
      type: SsoLoginActionTypes.SSO_LOGIN_SUCCESS
    });
    openPopup({
      url: response.redirectUrl,
      title: 'ssoLoginPopup',
      w: POPUP_WINDOW.width,
      h: POPUP_WINDOW.height
    });

    const getEventDataFromPopup = event => {
      if (event.origin === getWindowUrl(undefined, 'app') || event.origin === getWindowUrl(undefined, 'app-eu1')) {
        if (event.data && event.data.type === SSO_LOGIN_POPUP_URL) {
          appCookieLogin.redirectOnLoginSuccess([{
            redirectUrl: event.data.url
          }]);
          window.removeEventListener('message', getEventDataFromPopup);
        } else if (event.data && event.data.type === SSO_LOGIN_POPUP_NEXTPATH) {
          setStateForLV(event.data, dispatch);
          history.push(event.data.nextPath);
          window.removeEventListener('message', getEventDataFromPopup);
        }
      }
    };

    window.addEventListener('message', getEventDataFromPopup, false);
  }).catch(({
    responseJSON,
    message
  }) => {
    if (isPopupError(message)) {
      return null;
    } else {
      return handleError({
        responseJSON,
        history,
        dispatch
      });
    }
  });
};